import ReactDOM from "react-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import ApplicationProvider from "./context/ApplicationContext";
import ApplicationForm from "./ApplicationForm";

// Create a client
const queryClient = new QueryClient();

const App = ({ courseID, type }) => {
  return (
    <QueryClientProvider client={queryClient}>
      <ApplicationProvider id={courseID}>
        <ApplicationForm type={type} />
      </ApplicationProvider>
    </QueryClientProvider>
  );
};

// Render App to DOM
const element = document.getElementById("applicationRoot");

if (element) {
  const type = element.getAttribute("data-course-type");
  const courseID = element.getAttribute("data-course-id");

  ReactDOM.render(<App type={type} courseID={courseID} />, element);
}
